import React, { useEffect, useState } from 'react';
import { BoxMessage, TransferDataBox } from './style';
import { MinusIcon, PlusIcon } from 'assets/icons/AntDeisgn_icons/iconStyle';
import { SweetSweetAlert } from 'component/sweetalert_components';

const TransferDataComponent = React.memo(
  ({ leftBoxData, rightBoxData, onChange, rightBoxTitle, leftBoxTitle, height, className }) => {
    const [targetKeys, setTargetKeys] = useState([]);

    useEffect(() => {
      setTargetKeys(rightBoxData);
    }, [rightBoxData.length]);

    const handleTransferChange = (nextTargetKeys, direction, moveKeys) => {
      const primaryGroupItem = leftBoxData.find((item) => moveKeys.includes(item.key) && item.primaryGroup);
      if (primaryGroupItem?.primaryGroup) {
        SweetSweetAlert({
          text: `The primary group '${primaryGroupItem.title}' cannot be removed!`,
          icon: 'info',
          buttonColor: 'blue',
        });
        return;
      }
      setTargetKeys(nextTargetKeys);
      const filterAddedData = leftBoxData.filter((item) => nextTargetKeys.includes(item.key));
      const filterRemovedData = rightBoxData.filter((item) => !nextTargetKeys.includes(item));
      const addedData = [];
      filterAddedData.forEach((item) => {
        if (!rightBoxData.includes(item.key)) {
          addedData.push({ title: item.title, dn: item.dn });
        }
      });
      const removedData = [];
      leftBoxData.forEach((item) => {
        if (filterRemovedData.includes(item.key)) {
          removedData.push({ title: item.title, dn: item.dn });
        }
      });
      onChange(addedData, direction, removedData);
    };

    return (
      <TransferDataBox
        dataSource={leftBoxData}
        targetKeys={targetKeys}
        onChange={handleTransferChange}
        render={(item) => (
          <span>
            {item.render ? item.render() : null} {item.title}
          </span>
        )}
        titles={[
          <BoxMessage className={`${className}-boxmessage-left`}> {leftBoxTitle}</BoxMessage>,
          <BoxMessage className={`${className}-boxmessage-right`}>{rightBoxTitle}</BoxMessage>,
        ]}
        showSelectAll={false}
        showSearch
        filterOption={(inputValue, option) => option.title.toLowerCase().includes(inputValue.toLowerCase())}
        listStyle={{
          width: 550,
          minWidth: 250,
          height: height ? height : 300,
          minHeight: 200,
        }}
        operations={[<PlusIcon />, <MinusIcon />]}
        className={`af-transferbox ${className}`}
      />
    );
  }
);

export default TransferDataComponent;
